<template>
  <v-card
    :loading="isProcessing"
    :disabled="isProcessing"
    width="600"
    class="mx-auto mt-16 py-3"
    rounded="lg"
  >
    <div class="d-flex justify-end mb-4 mr-3">
      <v-icon @click="$router.back()">mdi-close</v-icon>
    </div>
    <!-- <div class="d-flex justify-end">
      <v-icon @click="$router.back()">mdi-close</v-icon>
    </div> -->
    <error-alert :message.sync="initialFetchError"></error-alert>
    <v-alert
      type="success"
      dismissible
      v-model="requestSuccess"
    >Updated Catalytic Converter</v-alert>
    <div
      class="px-3 px-md-10"
      v-if="!initialFetchError"
    >
      <v-card-title class="pl-0">{{ isEdit ? "Edit Catalytic Converter" : "Add Catalytic Converter" }}</v-card-title>
      <v-row
        class="mb-6"
        v-if="isEdit"
      >
        <v-col sm="6">
          <v-img
            @mouseover="imageHovered = true"
            @mouseleave="imageHovered = false;"
            :src="imageUrl ? imageUrl : '/images/not-available.png'"
            @click="imageClicked"
          >
            <v-overlay
              v-if="imageUrl"
              :value="imageHovered"
              absolute
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-overlay>
          </v-img>
          <div
            class="d-flex justify-end"
            v-if="imageUrl"
          >
            <v-btn
              small
              color="primary"
              text
              @click="removeImage"
            >Remove Image</v-btn>
          </div>
        </v-col>
        <v-col sm="6">
          <v-img
            @mouseover="image2Hovered = true"
            @mouseleave="image2Hovered = false;"
            :src="image2Url ? image2Url : '/images/not-available.png'"
            @click="image2Clicked"
          >
            <v-overlay
              v-if="image2Url"
              :value="image2Hovered"
              absolute
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-overlay>
          </v-img>
          <div
            class="d-flex justify-end"
            v-if="image2Url"
          >
            <v-btn
              small
              color="primary"
              text
              @click="removeImage2"
            >Remove Image</v-btn>
          </div>
        </v-col>
        <v-col sm="6">
          <v-img
            @mouseover="image3Hovered = true"
            @mouseleave="image3Hovered = false;"
            :src="image3Url ? image3Url : '/images/not-available.png'"
            @click="image3Clicked"
          >
            <v-overlay
              v-if="image3Url"
              :value="image3Hovered"
              absolute
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-overlay>
          </v-img>
          <div
            class="d-flex justify-end"
            v-if="image3Url"
          >
            <v-btn
              small
              color="primary"
              text
              @click="removeImage3"
            >Remove Image</v-btn>
          </div>
        </v-col>
        <v-col sm="6">
          <v-img
            @mouseover="image4Hovered = true"
            @mouseleave="image4Hovered = false;"
            :src="image4Url ? image4Url : '/images/not-available.png'"
            @click="image4Clicked"
          >
            <v-overlay
              v-if="image4Url"
              :value="image4Hovered"
              absolute
            >
              <v-icon>mdi-open-in-new</v-icon>
            </v-overlay>
          </v-img>
          <div
            class="d-flex justify-end"
            v-if="image4Url"
          >
            <v-btn
              small
              color="primary"
              text
              @click="removeImage4"
            >Remove Image</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-form
        v-model="valid"
        ref="form"
      >
        <v-text-field
          label="Code/ Grade Name"
          v-model="catalyticConverter.code"
          :rules="[requiredRule]"
          outlined
          dense
        ></v-text-field>
        <v-text-field
          label="Manufacturer"
          v-model="catalyticConverter.manufacturer"
          :rules="[requiredRule]"
          outlined
          dense
        ></v-text-field>
        <v-text-field
          label="Description"
          v-model="catalyticConverter.description"
          outlined
          dense
        ></v-text-field>
        <v-text-field
          label="Platinum Amount"
          v-model="catalyticConverter.platinum_amount_ounces"
          outlined
          suffix="oz"
          :rules="[requiredRule, nonNegativeRule]"
          type="number"
          :min="0"
          dense
        ></v-text-field>
        <v-text-field
          label="Palladium Amount"
          v-model="catalyticConverter.palladium_amount_ounces"
          outlined
          suffix="oz"
          :rules="[requiredRule, nonNegativeRule]"
          type="number"
          :min="0"
          dense
        ></v-text-field>
        <v-text-field
          label="Rhodium Amount"
          v-model="catalyticConverter.rhodium_amount_ounces"
          outlined
          suffix="oz"
          :rules="[requiredRule, nonNegativeRule]"
          type="number"
          :min="0"
          dense
        ></v-text-field>
        <v-file-input
          v-model="catalyticConverter.image"
          chips
          dense
          :label="isEdit ? 'Upload New Image' : 'Upload Image'"
          accept="image/*"
        ></v-file-input>
        <v-file-input
          v-model="catalyticConverter.image_2"
          chips
          dense
          :label="isEdit ? 'Upload New Image 2' : 'Upload Image 2'"
          accept="image/*"
        ></v-file-input>
        <v-file-input
          v-model="catalyticConverter.image_3"
          chips
          dense
          :label="isEdit ? 'Upload New Image 3' : 'Upload Image 3'"
          accept="image/*"
        ></v-file-input>
        <v-file-input
          v-model="catalyticConverter.image_4"
          chips
          dense
          :label="isEdit ? 'Upload New Image 4' : 'Upload Image 4'"
          accept="image/*"
        ></v-file-input>
      </v-form>
      <error-alert
        :message.sync="requestError"
        :validationMessages="requestValidationErrors"
      ></error-alert>
      <vehicles-dailog
        :isAdd="!isEdit"
        :isEdit="isEdit"
        :converterId="id"
        @save-vehicles="handleSaveVehicles"
        v-if="isAdmin"
      ></vehicles-dailog>
      <v-row class="mt-0">
        <v-col v-if="isEdit">
          <v-btn
            block
            color="error"
            @click="resetClicked"
          >Reset</v-btn>
        </v-col>
        <v-col>
          <v-btn
            block
            color="success"
            @click="validateAndAddOrEditConverter"
          >{{ isEdit ? "Update" : "Add"}}</v-btn>
        </v-col>
      </v-row>
    </div>
    <!-- different way of showing loading
      <v-overlay
      :value="convertersIsLoading"
      absolute
    >
      <v-progress-circular
        indeterminate
        size="50"
        color="primary"
      ></v-progress-circular>
    </v-overlay> -->
    <v-snackbar
      v-model="vehiclesSaveErrorSnackbar"
      color="error"
    >
      Vehicles update failed. {{ vehiclesSaveErrorMessage ? 'Error: ' + vehiclesSaveErrorMessage: ''  }}
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="vehiclesSaveErrorSnackbar = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapMutations } from "@/store/modules/catalyticConverters";
import { extractDataAxios, extractErrorMessageAxios, extractValidationErrorsAxios } from "@/httpClient";
import { mapGetters as userMapGetters } from "@/store/modules/user";
import VehiclesDailog from "./VehiclesDailog.vue";

export default {
  components: { VehiclesDailog },
  props: {
    isEdit: Boolean,
    id: [String, Number],
  },

  data: () => ({
    valid: false,
    imageUrl: null,
    image2Url: null,
    image3Url: null,
    image4Url: null,
    isImageRemoved: false,
    isImage2Removed: false,
    isImage3Removed: false,
    isImage4Removed: false,
    catalyticConverter: {
      code: null,
      manufacturer: null,
      description: null,
      platinum_amount_ounces: null,
      palladium_amount_ounces: null,
      rhodium_amount_ounces: null,
      image: null,
      image_2: null,
      image_3: null,
      image_4: null,
      vehicleIds: [],
    },
    requiredRule: (value) => !!value || "Required",
    nonNegativeRule: (v) => (!isNaN(v) && v >= 0) || "Must be a positive number",
    isProcessing: false,
    requestError: null,
    requestSuccess: false,
    requestValidationErrors: null,
    initialFetchError: null,
    initialData: null,
    imageHovered: false,
    image2Hovered: false,
    image3Hovered: false,
    image4Hovered: false,
    vehiclesSaveErrorSnackbar: false,
    vehiclesSaveErrorMessage: null,
  }),

  created: function () {
    if (this.isEdit) {
      if (!this.id) {
        this.initialFetchError = "Missing Catalytic Converter id to be edited";
        return;
      }
      this.fetchData();
    }
  },
  computed: {
    ...userMapGetters(["isAdmin"]),
  },
  methods: {
    ...mapMutations({
      ADD_CONVERTER: "ADD",
      EDIT_CONVERTER: "EDIT",
    }),

    updateWithNewImageData() {
      // take out the image in a separate variable
      // the vuetify file input doesn't accept file URLs
      if (this.catalyticConverter.image) {
        this.imageUrl = this.catalyticConverter.image;
      }
      if (this.catalyticConverter.image_2) {
        this.image2Url = this.catalyticConverter.image_2;
      }
      if (this.catalyticConverter.image_3) {
        this.image3Url = this.catalyticConverter.image_3;
      }
      if (this.catalyticConverter.image_4) {
        this.image4Url = this.catalyticConverter.image_4;
      }
      this.catalyticConverter.image = null;
      this.catalyticConverter.image_2 = null;
      this.catalyticConverter.image_3 = null;
      this.catalyticConverter.image_4 = null;
    },

    async fetchData() {
      this.isProcessing = true;
      try {
        const data = extractDataAxios(await window.axios.get("/api/catalytic-converters/" + this.id));
        if (data) {
          for (let key of Object.keys(this.catalyticConverter)) {
            if (data[key]) {
              this.catalyticConverter[key] = data[key];
            }
          }
          this.initialData = { ...this.catalyticConverter };
          this.updateWithNewImageData();
          this.isProcessing = false;
        }
      } catch (e) {
        console.error(e);
        this.isProcessing = false;
        this.initialFetchError = "Failed to fetch the converter. Error: " + extractErrorMessageAxios(e);
      }
    },

    resetClicked() {
      this.catalyticConverter = { ...this.initialData };
      this.updateWithNewImageData();
      // lets put the image view back, in case it was removed
      this.isImageRemoved = false;
      this.isImage2Removed = false;
      this.isImage3Removed = false;
      this.isImage4Removed = false;
    },

    imageClicked() {
      if (this.imageUrl) {
        window.open(this.imageUrl, "_blank").focus();
      }
    },
    image2Clicked() {
      if (this.image2Url) {
        window.open(this.image2Url, "_blank").focus();
      }
    },
    image3Clicked() {
      if (this.image3Url) {
        window.open(this.image3Url, "_blank").focus();
      }
    },
    image4Clicked() {
      if (this.image4Url) {
        window.open(this.image4Url, "_blank").focus();
      }
    },

    removeImage() {
      this.isImageRemoved = true;
      this.imageUrl = null;
    },
    removeImage2() {
      this.isImage2Removed = true;
      this.image2Url = null;
    },
    removeImage3() {
      this.isImage3Removed = true;
      this.image3Url = null;
    },
    removeImage4() {
      this.isImage4Removed = true;
      this.image4Url = null;
    },

    validateAndAddOrEditConverter() {
      this.$refs.form.validate();
      if (this.valid) {
        let formData = new FormData();
        for (const [key, value] of Object.entries(this.catalyticConverter)) {
          if (value !== null) {
            Array.isArray(value)
              ? value.forEach((arrVal) => formData.append(key + "[]", arrVal))
              : formData.append(key, value);
          }
        }
        if (this.isEdit) {
          this.editConverter(formData);
        } else {
          this.addNewConverter(formData);
        }
      }
    },

    async addNewConverter(formData) {
      this.isProcessing = true;
      try {
        const data = extractDataAxios(
          await window.axios.post("/api/catalytic-converters", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        );
        if (data) {
          this.ADD_CONVERTER(data);
          this.$router.push({ name: "catalytic-converters" });
        }
      } catch (e) {
        console.error(e);
        this.requestError = "Adding new converter failed. Error: " + extractErrorMessageAxios(e);
        this.requestValidationErrors = extractValidationErrorsAxios(e);
      } finally {
        this.isProcessing = false;
      }
    },

    async editConverter(formData) {
      formData.append("_method", "put");
      formData.append("remove_image", this.isImageRemoved ? "1" : "0");
      formData.append("remove_image_2", this.isImage2Removed ? "1" : "0");
      formData.append("remove_image_3", this.isImage3Removed ? "1" : "0");
      formData.append("remove_image_4", this.isImage4Removed ? "1" : "0");
      this.isProcessing = true;
      this.requestError = null;
      this.requestValidationErrors = null;
      try {
        const data = extractDataAxios(
          await window.axios.post("/api/catalytic-converters/" + this.id, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        );
        if (data) {
          this.EDIT_CONVERTER(data);
          this.requestSuccess = true;
          for (let key of Object.keys(this.catalyticConverter)) {
            if (data[key]) {
              this.catalyticConverter[key] = data[key];
            }
          }
          this.initialData = { ...this.catalyticConverter };

          this.updateWithNewImageData();
        }
      } catch (e) {
        console.error(e);
        this.requestError = "Editing converter failed. Error: " + extractErrorMessageAxios(e);
        this.requestValidationErrors = extractValidationErrorsAxios(e);
      } finally {
        this.isProcessing = false;
      }
    },

    async handleSaveVehicles(vehicles) {
      if (this.isEdit) {
        this.vehiclesSaveErrorMessage = null;
        try {
          const data = extractDataAxios(
            await window.axios.post(`/api/catalytic-converters/${this.id}/vehicles`, {
              vehicleIds: vehicles.map((vehicle) => vehicle.id),
            })
          );
        } catch (e) {
          console.error(e);
          this.vehiclesSaveErrorSnackbar = true;
          this.vehiclesSaveErrorMessage = extractErrorMessageAxios(e);
        }
      } else {
        this.catalyticConverter.vehicleIds = vehicles.map((vehicle) => vehicle.id);
      }
    },
  },
};
</script>
